import { message } from 'antd';
import { downloadProjectFeedback } from 'HttpRequests/projectFeedback';

export default (feedback) => async (dispatch, getState) => {
  const state = getState();
  const project = state.screens.ProjectView.project;

  if (!project || !feedback) {
    message.error('Project or feedback data not available');
    return;
  }

  if (feedback.status !== 'completed') {
    message.warning('Feedback must be completed before downloading PDF');
    return;
  }

  try {
    message.loading('Generating PDF...', 0);
    
    const response = await downloadProjectFeedback({ 
      projectId: project.id,
      feedbackId: feedback.id
    });

    message.destroy();

    // Check if response is actually a blob
    if (response.data instanceof Blob) {
      // Create blob link to download
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Feedback-${project.number}-${feedback.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success('Feedback PDF downloaded successfully');
    } else {
      console.error('Response is not a blob:', response);
      message.error('Invalid PDF response from server');
    }

  } catch (error) {
    message.destroy();
    console.error('Error downloading feedback:', error);
    
    if (error.response && error.response.data && error.response.data.error) {
      message.error(error.response.data.error);
    } else {
      message.error('Failed to download feedback PDF');
    }
  }
};
